export class SpecialistEncounterVerification {
  id: any;
  encounterDate: string;
  frozen: boolean;
  createdAt: string;
}
